/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SamplerIcon = ({ width = 24, height = 24, hidden = false, title = 'Sampler' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M22.457 17.037 8.232 31.262a2.471 2.471 0 1 1-3.494-3.494l14.225-14.225Zm7.271-14.931a3.591 3.591 0 0 0-2.546 1.055l-4.525 4.525-1.414-1.414a1 1 0 0 0-1.414 0l-3.362 3.361a1 1 0 0 0 0 1.414l1.081 1.082L3.324 26.354a4.47 4.47 0 1 0 6.322 6.322l14.225-14.224 1.082 1.081a1 1 0 0 0 1.414 0l3.361-3.361a1 1 0 0 0 0-1.415l-1.414-1.414 4.525-4.525a3.6 3.6 0 0 0 0-5.092l-.565-.565a3.592 3.592 0 0 0-2.546-1.055Z"
    />
  </svg>`;
};
